

















import { Component, Vue, Prop } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import ApiClient from '@/data/ApiClient';
import Card from '@/components/default/Card.vue';
import Datagrid from '@/components/default/Datagrid.vue';
import Project from '@/classes/Project';

@Component({
  components: {
    Card,
    Datagrid,
  },
})
export default class ContractsTable extends Vue {
  @Prop({required: true})
  public project!: Project;

  @Prop({ required: false, default: false})
  public disabled!: boolean;

  public openDetails(e: any) {
    if (e && e.row && !e.row.isEditing && e.column && e.column.type !== 'buttons' && this.project) {
      this.$router.push({ path: `/contracts/${e.row.data.documentNumber.replace('/', '-').replace('/', '-')}` });
    }
  }

  public deleteContract(e: any) {
    const self = this;
    e.cancel = new Promise(async (resolve, reject) => {
      try {

        if (e && e.data && e.data.documentNumber) {
          const documentnumber: string = (e.data.documentNumber as string)
            .replace('/', '-')
            .replace('/', '-');

          await ApiClient.projects.contracts.delete(e.data.documentNumber);

          notificationService.saved();
        }

        resolve(false);
      } catch (err) {
        notificationService.failedToSave();
        reject(false);
      }
    });
  }

  get columns() {
    return [
      {
        dataField: 'documentNumber',
        caption: 'Documentnr.',
      },
      {
        dataField: 'subcontractorName',
        caption: 'Onderaannemer',
      },
      {
        dataField: 'date',
        caption: 'Datum',
        dataType: 'date',
        format: 'dd/MM/yyyy',
      },
      {
        dataField: 'status',
        caption: 'Status',
        lookup: {
          displayExpr: 'text',
          valueExpr: 'value',
          items: ApiClient.projects.contracts.getStatusOptions(),
        },
      },
      {
        dataField: 'projectType',
        caption: 'Soort project',
      },
      {
         dataField: 'reference',
        caption: 'Referentie',
      },
    ];
  }
}
